import React, { useState, useCallback } from "react";
import styles from "./NAOrderDetailsNewVersion.module.scss";
import { withTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import crStyles from "../../customerReservation/crStyles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../shared/ExpansionPanels/ExpansionPanel";
import { InfoDetail } from "./InfoDetail";

function DealerInformation({ dealerInfo, t, isNAMarket }) {
  const [expandDealerInfo, setExpandDealerInfo] = useState(false);

  const handleExpandDealerInfo = useCallback(() => {
    setExpandDealerInfo((prevState) => !prevState);
  }, []);

  return (
    <StyledBasicExpansionPanel
      defaultExpanded={true}
      onChange={handleExpandDealerInfo}
    >
      <StyledBasicExpansionPanelSummary
        style={crStyles.orderDetailsExpansion}
        id="exp"
      >
        <div className={styles.headerBar}>
          <div className={styles.headerMargin}>
            <span className={styles.boldHeader}>
              {t("DealerInfo.dealerInformation")}
            </span>
          </div>
          {!expandDealerInfo ? (
            <ExpandLessIcon id="less" />
          ) : (
            <ExpandMoreIcon id="more" />
          )}
        </div>
      </StyledBasicExpansionPanelSummary>
      <div className={styles.customerInfoGrid}>
        <div className={styles.bottomBorder} />
        {dealerInfo ? (
          <Grid container className={styles.customerContainer}>
            <Grid item xs={3}>
              <div className={styles.subHeaderText}>
                {t("DealerInfo.dealerDetails")}
              </div>

              <InfoDetail
                header={t("DealerInfo.dealerName")}
                value={dealerInfo.name}
              />
              <>
                <div className={styles.itemHeaderText}>
                  {t("DealerInfo.dealerAddress")}
                </div>

                <div
                  className={`${styles.smallHeaderMargin} ${styles.customerInfoContainer}`}
                >
                  <div className={styles.customerInfoTextBold}>
                    {dealerInfo.addressLine1}
                  </div>
                  <div className={styles.customerInfoTextBold}>
                    {dealerInfo.addressLine2}
                  </div>
                </div>
              </>
              <InfoDetail
                header={t("DealerInfo.dealerPhone")}
                value={dealerInfo.phone}
              />
              {isNAMarket ? (
                <>
                  <InfoDetail
                    header={t("DealerInfo.dealerPACode")}
                    value={dealerInfo.paCode}
                  />
                  <InfoDetail
                    header={t("DealerInfo.dealerSalesCode")}
                    value={dealerInfo.salesCode}
                  />
                </>
              ) : (
                <InfoDetail
                  header={t("DealerInfo.dealerId")}
                  value={dealerInfo.dealerId}
                />
              )}
            </Grid>
          </Grid>
        ) : (
          <span className={styles.labelError}>
            {" "}
            {t("CustomerOrderDetails.errorLoadingCustomerInfo")}
          </span>
        )}
      </div>
    </StyledBasicExpansionPanel>
  );
}

export default withTranslation("emp")(DealerInformation);
